<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="pop">
    <div class="info">
      <img src="@/assets/pop-title.png" class="popbg" />
      <img src="@/assets/pop-border.png" class="borderleft" />
      <img src="@/assets/pop-border.png" class="borderright" />
      <div class="title">
        土地信息
        <img src="@/assets/guanbi.png" class="close" @click="close" />
      </div>
      <el-scrollbar height="682px">
        <div class="name">
          <span class="point"></span>基础信息
        </div>
        <div class="table">
          <div class="head">地块编号</div>
          <div class="val">410212103200000002</div>
          <div class="head">地块名称</div>
          <div class="val">小麦2号</div>
          <div class="head">地块面积</div>
          <div class="val">402亩</div>
          <div class="head">地块用途</div>
          <div class="val">大田</div>
        </div>
        <div class="name"><span class="point"></span>经营主体</div>
        <div class="table">
          <div class="head">经营主体</div>
          <div class="val">曲兴镇</div>
          <div class="head">法人代表(负责人)</div>
          <div class="val">黄**</div>
          <div class="head">联系方式</div>
          <div class="val">137****0514</div>
          <div class="head">主体类型</div>
          <div class="val">农业企业</div>
          <div class="head">经营类目</div>
          <div class="val">粮食</div>
          <div class="head">主体唯一标识</div>
          <div class="val">9242**********7F6W</div>
        </div>
        <div class="name"><span class="point"></span>种养品种</div>
        <div class="type">当前种养品种</div>
        <div class="table">
          <div class="head">品种</div>
          <div class="val">大蒜-金蒜5号</div>
          <div class="head">种植时间</div>
          <div class="val">2024-12-07（第174天）</div>
          <div class="head">农事操作</div>
          <div class="val btn"  @click="open">
            <img src="../../../assets/Vector@2x.png" class="icon" />查看操作记录
          </div>
        </div>
        <div class="type">历史种养品种</div>
        <div class="table" v-for="i in 3" :key="i">
          <div class="head">品种</div>
          <div class="val">大蒜-金蒜5号</div>
          <div class="head">种植时间</div>
          <div class="val">2024-12-07（第174天）</div>
          <div class="head">农事操作</div>
          <div class="val btn" @click="open">
            <img src="../../../assets/Vector@2x.png" class="icon" />查看操作记录
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script setup>
import { defineEmits, onMounted } from "vue";
const emit = defineEmits(["close","openRecords"]);

const close = () => {
  emit("close");
};
const open = ()=>{
  emit('openRecords')
}
onMounted(() => {});
</script>
<style lang="scss" scoped>
.pop {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba($color: #000000, $alpha: 0.6);
  .info {
    width: 897px;
    height: 732px;
    background: linear-gradient(180deg, #002002 0%, #002603 100%);
    box-shadow: 0px 4px 50px 0px #000000;
    border: 2px solid #055a17;
    margin: 9vh auto;
    display: flex;
    flex-direction: column;
    position: relative;
    color: #fff;
    font-size: 14px;
    .popbg {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .borderleft {
      width: 24px;
      position: absolute;
      left: -1px;
      bottom: -1px;
      transform: rotate(90deg);
    }
    .borderright {
      width: 24px;
      position: absolute;
      bottom: -1px;
      right: -1px;
    }
    .title {
      width: 100%;
      font-size: 28px;
      line-height: 50px;
      letter-spacing: 2px;
      text-shadow: 0px 3px 3px rgba(0, 95, 25, 0.3);
      color: #fff;
      font-family: "YouSheBiaoTiHei";
      padding: 0 16px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 1000;
      .close {
        width: 28px;
        height: 28px;
        cursor: pointer;
      }
    }
    .name {
      width: 830px;
      height: 32px;
      background: rgba(8, 213, 52, 0.2);
      margin: 28px 32px 0px 32px;
      line-height: 32px;
      font-weight: bold;
      padding: 0 16px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      gap: 10px;
      border: 1px solid transparent;
      .point {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 3px;
        background-color: #08d516;
      }
    }
    .table {
      width: 829px;
      min-height: 80px;
      box-sizing: border-box;
      margin: 12px auto;
      display: flex;
      flex-wrap: wrap;
      gap: 1px;
      background: rgba(96, 255, 144, 0.4);
      border: 1px solid rgba(96, 255, 144, 0.4);
      .head {
        width: 132px;
        height: 40px;
        line-height: 40px;
        padding: 0 16px;
        box-sizing: border-box;
        text-align: right;
        background: #004304;
      }
      .val {
        width: 280px;
        height: 40px;
        line-height: 40px;
        padding: 0 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        gap: 8px;
        background: #002603;
        .icon {
          width: 17px;
          height: 20px;
        }
      }
      .btn {
        width: 694px;
        cursor: pointer;
        color: #41d74b;
        opacity: 1;
        border-right: transparent;
      }
    }
    .type {
      color: #41d74b;
      margin: 12px 32px 8px 32px;
    }
  }
}
</style>
